export const homePages = [
  'home',
  '/en/home-page/',
  '/de/startseite/',
  '/es/pagina-principal/',
];
